module.exports = __webpack_public_path__ + "static/media/strong36.32cbf9de.jpg";